import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {Collect} from '../models/collect';

@Injectable({
  providedIn: 'root'
})
export class CollectService {

  constructor (private db: AngularFirestore) { }

  select () {
    return this.db.collection<Collect>('sbccv_members_collect', ref => ref
      .orderBy('date', 'desc')
    ).snapshotChanges();
  }

  selectByMember (member_id: string) {
    return this.db.collection<Collect>('sbccv_members_collect', ref => ref
      .where('member_id', '==', member_id)
      .orderBy('date', 'desc'))
      .snapshotChanges()

  }

  getById (id) {
    return this.db.doc<Collect>('sbccv_members_collect/' + id)
      .snapshotChanges();
  }

  insert (entity: Collect) {
    return this.db.collection('sbccv_members_collect').add(Object.assign({}, entity));
  }

  update (id: string, entity: Collect) {
    return this.db.collection('sbccv_members_collect').doc(id).update(Object.assign({}, entity));
  }

  archive (id: string, archived: boolean) {
    return this.db.collection('sbccv_members_collect').doc(id).update({ 'archived': archived});
  }

  set (id: string, entity: Collect) {
    return this.db.collection('sbccv_members_collect').doc(id).set(Object.assign({}, entity), {'merge': true});
  }

  updateStatus (id: string, status: string) {
    return this.db.collection('sbccv_members_collect').doc(id).update({'status': status});
  }

  delete (entity_id: any) {
    return this.db.collection('sbccv_members_collect').doc(entity_id).delete();
  }

  createCollect (id, data) {
    const collect = new Collect()
    collect.id = id;
    collect.date = data.date;
    collect.status = data.status;
    collect.member_id = data.member_id;
    collect.member_name = data.member_name;
    collect.member_email = data.member_email;
    collect.member_cpf = data.member_cpf;
    collect.qtd = data.qtd;
    collect.value = data.value;
    collect.collect = data.collect;
    collect.pix = data.pix || []

    return collect;
  }

}
